module.exports = __webpack_public_path__ + "static/media/21ECLAC12.d6b6a97f.jpg";